import styled from 'styled-components';

const MARKER_CENTER_OFFSET_TOP = 21.31;
const MARKER_CENTER_OFFSET_LEFT = 7.99;

const AnnotationIconContainer = styled.div`
  position: absolute;
  top: ${props => props.top - MARKER_CENTER_OFFSET_TOP}px;
  left: ${props => props.left - MARKER_CENTER_OFFSET_LEFT}px;
  visibility: ${props => (props.isVisible ? 'visible' : 'hidden')};
`;

export default { AnnotationIconContainer };
